import React, { useEffect, useState } from "react";
import {
  Dimensions,
  Image,
  ImageBackground,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import api from "../config/api_urls";
import Menu from "../menu";
import style from "../../Styles/perfil";
import PopUpPerfilImatge from "../PopUps/PopUpPerfilImatge";
import globalstyle from "../../Styles/Globals/globals";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";
import PremiMultimedia from "../Premi/PremiMultimedia";

function ImatgesItinerari(RouterData) {
  const { idioma, projecte, recursos, perfilImatges } = RouterData.route.params;

  const [premis, setPremis] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [ShowPremi, setShowPremi] = useState(null);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    const currentPremis = projecte.premis.filter(
      (e) => e.itinerari === perfilImatges.itinerari,
    );
    setPremis(currentPremis);
  }, []);

  const renderVistaItinerari = () => {
    let items = [];
    switch (perfilImatges.estat) {
      case "no visitat":
        premis.map((premi, index) => {
          if (!premi.superPremi) {
            items.push(
              <View style={[style.premiContainer]} key={index}>
                <TouchableOpacity style={[style.premiImage, { opacity: 0.2 }]}>
                  {PremiMultimedia(premi)}
                </TouchableOpacity>
              </View>,
            );
          }
        });
        break;

      case "finalitzat":
        premis.map((premi, index) => {
          if (!premi.superPremi) {
            items.push(
              <View style={[style.premiContainer]} key={index}>
                <TouchableOpacity
                  style={[style.premiImage]}
                  onPress={() => {
                    setShowPremi(premi);
                    setModalVisible(true);
                  }}
                >
                  {PremiMultimedia(premi)}
                </TouchableOpacity>
              </View>,
            );
          }
        });
        break;

      case "comencat":
        premis.map((premi, index) => {
          if (!premi.superPremi) {
            items.push(
              <View style={[style.premiContainer]} key={index}>
                <TouchableOpacity
                  style={[
                    style.premiImage,
                    perfilImatges.pois[index]?.done ? null : { opacity: 0.2 },
                  ]}
                  onPress={() => {
                    if (perfilImatges.pois[index]?.done) {
                      setShowPremi(premi);
                      setModalVisible(true);
                    }
                  }}
                >
                  {PremiMultimedia(premi)}
                </TouchableOpacity>
              </View>,
            );
          }
        });
        break;
    }

    return items;
  };

  const showSuperPremi = () => {
    let premiUrl = premis.find((e) => e.superPremi)?.Premi.url;
    if (perfilImatges.estat === "finalitzat" || perfilImatges.showSuperPremi) {
      if (premiUrl) {
        return (
          <View style={style.superPremiContainer}>
            <Image
              style={style.image}
              source={{ uri: api.api_url + premiUrl }}
            />
          </View>
        );
      } else {
        return null;
      }
    } else {
      if (premiUrl) {
        return (
          <View style={style.superPremiContainer}>
            <Image
              style={style.image}
              source={{
                uri: getRecursURL(recursos, "superPremi", idioma),
              }}
            />
          </View>
        );
      }
    }
  };

  const showPremiAlternatiu = () => {
    if (perfilImatges.estat == "finalitzat") {
      return (
        <TouchableOpacity
          style={{ width: "80%", height: "50%" }}
          onPress={() => {
            setShowVideo(true);
          }}
        >
          <Image
            style={[style.image]}
            source={{
              uri:
                api.api_url +
                projecte.premi_alternatiuses.find(
                  (e) => e.itinerari == perfilImatges.itinerari,
                )?.Imatge2.url,
            }}
          />
        </TouchableOpacity>
      );
    }

    return (
      <Image
        style={{ width: "80%", height: "50%", resizeMode: "contain" }}
        source={{
          uri:
            api.api_url +
            projecte.premi_alternatiuses.find(
              (e) => e.itinerari == perfilImatges.itinerari,
            )?.Imatge1.url,
        }}
      />
    );
  };

  if (showVideo) {
    //=> Mostrar video de premi alternatiu ( esta guardat en local )
    return (
      <View id="videoContainer" style={style.videoContainer}>
        {/* <video id="video" onPause={ e => this.explanation() }
              style={{
                  height: '100%',
                  width: '100vw',
                  resizeMode: 'contain',
                  objectFit: 'contain',
                  position: 'fixed',
                  left: 0,
                  top: 0,
                  zIndex: -1
              }}
          autoPlay>
              <source id="videoSource"  src={require("../../../assets/Videos/PemisItinerari/"+perfilImatges.Nom+".mp4")} type="video/mp4" />
          </video> */}
        <TouchableOpacity
          style={globalstyle.crossBox}
          onPress={() => {
            setShowVideo(false);
          }}
        >
          <Image
            source={{
              uri: getRecursURL(recursos, "pop_up_close_icon", idioma),
            }}
            style={globalstyle.cross}
          />
        </TouchableOpacity>
      </View>
    );
  }
  return (
    <View style={{ flex: 1 }}>
      {modalVisible &&
        PopUpPerfilImatge(ShowPremi, modalVisible, setModalVisible)}

      <ImageBackground
        source={getRecursURL(recursos, "background_default", idioma)}
        style={{ flex: 1, resizeMode: "cover" }}
      >
        <View
          style={{ flex: 20, justifyContent: "center", alignItems: "center" }}
        >
          <View
            style={[
              style.boxNom,
              { backgroundColor: projecte.colorPrincipal2 },
            ]}
          >
            <Text style={style.nomIter}>{perfilImatges.Nom}</Text>
          </View>
        </View>
        <View
          style={{
            flex: 20,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View
            style={[
              style.boxNom,
              {
                width: "60%",
                height: "40%",
                borderWidth: "1px",
                backgroundColor: projecte.colorPrincipal2,
              },
            ]}
          >
            <Text style={[style.SecondTitle]}>
              {getRecursText(recursos, "total_itinerari", idioma)}
            </Text>
            <Text style={style.SecondText}>
              {perfilImatges.estat != "no visitat" ? perfilImatges.punts : 0}{" "}
            </Text>
          </View>
        </View>
        {/* <View style={{flex:20 , flexDirection:'row' }}>
            <View style={{flex:1, justifyContent:'center',alignItems:'center', width:'60%'}}>
              <Text style={style.SecondTitle}>{recursos.find(e => e.tipus_recurs === 'total_itinerari')['text_recurs' + idioma]}</Text>
              <Text style={style.SecondText}>{perfilImatges.estat != "no visitat" ? perfilImatges.punts : 0} </Text>
            </View>
            <View style={{flex:1, justifyContent:'center',alignItems:'center', width:'30%',paddingRight:'5%'}}>
              {showPremiAlternatiu()}
            </View>
          </View> */}
        {/* <View style={{flex:10}}>
            {showSuperPremi()}
          </View> */}
        <View style={{ flex: 50, alignContent: "center", alignSelf: "center" }}>
          <ScrollView
            style={{
              flex: 1,
              maxHeight: "100%",
              width: Dimensions.get("screen").width * 0.7,
            }}
          >
            <View
              style={{
                flexWrap: "wrap",
                flexDirection: "row",
                width: "100%",
                alignContent: "center",
                placeContent: "center",
                justifyContent: "center",
              }}
            >
              {renderVistaItinerari()}
            </View>
          </ScrollView>
        </View>
        <View style={{ flex: 10 }}>
            <Menu projecte={RouterData.route.params}></Menu>
        </View>
      </ImageBackground>
    </View>
  );
}

export default ImatgesItinerari;
